import React from 'react';
import Header from './Header';
import BottomNavigation from './BottomNavigation';
import './Layout.css';

const Layout = ({ children, title, description }) => {
  return (
    <div className="container">
      <Header title={title} description={description} />
      <div className="content">
        {children}
      </div>
      <BottomNavigation />
    </div>
  );
};

export default Layout; 